import React from "react";
import { Provider } from "react-redux";
import { store } from "./redux_store";
import { initDoc } from "./AppConfig";
import App from "./App";

function index() {
    initDoc();

    return (
        <Provider store={store}>
            <App />
        </Provider>
    );
}

export default index;
